<!--
 * @Author: linrui
 * @Date: 2021-12-22 09:15:13
 * @LastEditors: linrui
 * @LastEditTime: 2022-01-07 16:03:08
 * @Description: 印章接收页
 * @FilePath: /wechat-frontend/zmtx/src/views/doctor/sealReceive.vue
-->
<template>
    <div class="upload-seal-receive">
        <div class="shadow-box">
            <div class="myuploader">
                <van-cell-group class="uploader-box" :border="false">
                    <template #title>
                        <div v-html="checkItem.name"></div>
                    </template>
                    <div class="uploader-subbox" v-if="checkItem.image" @click="handleImagePreview">
                        <div class="uploader-subtitle">示例图片</div>
                        <van-row type="flex" gutter="20">
                            <van-col>
                                <van-image width="120" fit="contain" height="80" :src="checkItem.image" />
                            </van-col>
                        </van-row>
                    </div>
                    <div class="van-uploader">
                        <div class="van-uploader__wrapper">
                            <div class="van-uploader__upload" @click="chooseImage()" v-if="num > 0">
                                <i class="van-icon van-icon-photograph van-uploader__upload-icon"></i>
                                <div class="van-uploader__input"></div>
                            </div>
                        </div>
                    </div>
                    <div class="uploader-subbox" v-if="images.length>0">
                        <div class="uploader-subtitle">已上传图片</div>
                        <van-row>
                            <van-col v-for="(hitem, hindex) in images" :key="hindex" @click="showPic(hitem.src)">
                                <van-image width="80" fit="contain" height="80" :src="hitem.src">
                                    <i class="van-icon van-icon-clear van-uploader__preview-delete" @click.stop="deleteImg(hitem,hindex)"></i>
                                </van-image>
                            </van-col>
                        </van-row>
                    </div>
                </van-cell-group>
            </div>
        </div>
        <p class="tips">您的备案材料已经完全审批通过，您可等待项目医生签章的发放，可在官网查询项目签章物流情况，签章接收后请提交签收章的图片，签收章图片项目办审核通过后您即正式成为援助项目医生。</p>
        <div class="page-ft btn">
            <van-row>
                <van-col span="8">
                    <van-button block class="back" @click="handleImagePreview">预览</van-button>
                </van-col>
                <van-col span="16">
                    <van-button block class="up" @click="submitUpload" :disabled="submitBtnDisabled">提交并保存</van-button>
                </van-col>
            </van-row>
        </div>
    </div>
</template>

<script>
    import {
        SubmitDocSignAttach,
        RemoveDocSignAttach,
        DownloadImage,
        GetDocSignAttach,
        GetDocSignExample
    }from '../../api/api'
    import {
        Toast,
        Dialog,
        ImagePreview
    } from 'vant'
    import {
        mapState
    } from "vuex"
    import ImageUploader from "@/components/ImageUploader"

    export default {
        name: "upload-item",
        components: {
            ImageUploader
        },
        data() {
            return {
                check_item_id: '',
                images: [],
                // images:[
                //     {src:'http://ecasev2-api.papv2.sungotech.com/upload/image/202112/03/4fdac9eb572912b83694eb04ad0f2ce2.jpg'},
                //     {src:'http://ecasev2-api.papv2.sungotech.com/upload/image/202112/03/4fdac9eb572912b83694eb04ad0f2ce2.jpg'}
                // ],
                checkItem: {
                    name: '签收章',
                    attach: [],
                    image: '',
                    status:'审核不通过'
                },
                submitBtnDisabled: false,
                isLoading:true
            };
        },
        computed: {
            ...mapState({
                doctorInfo: state => state.doctor.doctorInfo,
            }),
            num() {
                let n = 0
                    n = 9 - this.images.length
                return n
            }
        },

        async created() {
            await this.getData()
        },

        methods: {
            async getData() {
                Toast.loading({
                    duration: 0, // 持续展示 toast
                    forbidClick: true
                });
                GetDocSignAttach({
                    params:{id:this.doctorInfo.id}
                }).then( res => {
                    if(res.data) {
                        res.data.forEach( item => {
                            this.images.push({
                                id:item.id,
                                src:`${this.baseUrl}${item.image}`
                            })
                        })
                    }
                    console.log(res,'签收表历史图片');
                }).catch( err => {
                    this.$toast(err.response.data.message)
                })
                GetDocSignExample().then( res => {
                    console.log(res,'签收表实例图片');
                    if(res.data) {
                        this.checkItem.image = `${this.baseUrl}${res.data.filepath}`
                    }
                }).catch( err => {
                    this.$toast(err.response.data.message)
                })
                Toast.clear()
            },

            //预览图片
            showPic(src) {
                let images = []
                images.push(src)
                ImagePreview({
                    images,
                    closeable: true,
                })
            },

            chooseImage(event) {
                this.wx.ready(() => {
                    this.wx.chooseImage({
                        count: this.num,
                        sizeType: ['compressed'], // 可以指定是原图还是压缩图，默认二者都有
                        sourceType: ['album', 'camera'], // 可以指定来源是相册还是相机，默认二者都有
                        success: async (res) => {
                            try {
                                for (let index = 0; index < res.localIds.length; index++) {
                                const serverId = res.localIds[index];
                                await this.uploadImage(serverId);
                                }
                            } catch (err) {
                                Toast(err.response.data.message);
                            }
                            // try {
                            //     const serverId = res.localIds[0] // 返回选定照片的本地ID列表，localId可以作为img标签的src属性显示图片
                            //     await this.uploadImage(serverId)
                            // } catch (err) {
                            //     this.$toast(err.response.data.message)
                            // }
                        },
                        fail: function (err) {
                            Toast('选图失败');
                            console.log(err)
                        }
                    })
                })
            },
            uploadImage(serverId) {
                return new Promise((resolve, reject) => {
                    this.wx.uploadImage({
                        localId: serverId,
                        isShowProgressTips: 1,
                        success: (res) => {
                            var serverId = res.serverId; // 返回图片的服务器端ID
                            this.isLoading = true
                            DownloadImage({
                                params: {
                                    serverId: serverId
                                }
                            }).then((res) => {
                                this.images.push({
                                    serverId: serverId,
                                    src: `${this.baseUrl}${res.data}`
                                })
                                this.isLoading = false
                                resolve()
                            })
                            .catch((err) => {
                                //  reject(err.response.data.message)
                                console.log(err)
                                this.isLoading = false
                                reject(err)
                            })
                        }
                    });
                });
            },

            //预览签收表
            handleImagePreview() {
                let tempImg = []
                tempImg.push(this.checkItem.image)
                ImagePreview({
                    images:tempImg,
                    closeable:true
                })
            },

            //上传印章签收表
            submitUpload() {
                if(this.images == 0) {
                    this.$toast('请上传图片')
                    return
                }
                this.$toast.loading({
                    duration:0,
                    forbidClick:true
                })
                this.submitBtnDisabled = true
                // let historyImages = []
                // historyImages = this.images.filter(item => item.id)
                // if(historyImages.length == 9) {
                //     this.$toast('请先更新图片，再提交')
                //     this.submitBtnDisabled = false
                //     return
                // }
                let tempImgs = []
                tempImgs = this.images.filter(item => !item.id).map( item => {
                    return {
                        src:item.src.split(this.baseUrl)[1]
                    }
                })
                console.log(tempImgs,'tempImgs');
                if(tempImgs.length == 0) {
                    this.$toast('请先更新图片，再提交')
                    this.submitBtnDisabled = false
                    return
                }
                SubmitDocSignAttach({
                    doctor_id:this.doctorInfo.id,
                    checkItems:tempImgs
                }).then( res => {
                    this.submitBtnDisabled = false
                    this.$router.replace({
                        name:'DoctorMsg',
                        query:{
                            value:'签收提交'
                        }
                    })
                    this.$toast.clear()
                }).catch( err => {
                    this.submitBtnDisabled = false
                    this.$toast.clear()
                    this.$toast(err.response.dat.message)
                })
            },
            
            deleteImg(item,index) {
                Dialog.confirm({
                    message: '确定删除？',
                })
                .then(() => {
                    if(item.id) {
                        RemoveDocSignAttach({
                            id:item.id
                        }).then( () => {
                            this.images.splice(index,1)
                            this.$forceUpdate();
                        }).catch((err) => {
                            Toast(err.response.data.message)
                        })                        
                    } else {
                        RemoveDocSignAttach({
                            src: this.images[index].src.split(this.baseUrl)[1]
                        }).then( () => {
                            this.images.splice(index,1)
                            this.$forceUpdate();
                        }).catch((err) => {
                            Toast(err.response.data.message)
                        })
                    }
                })
                .catch((err) => {
                    // console.log(err);
                });
            }
        },
    };
</script>

<style lang="less">
    .upload-seal-receive {
        padding-top: 2px;
        box-sizing: border-box;

        .myuploader {
            background: #fff;
        }

        .upload-status {
            padding: 10px 15px;
            font-size: 14px;

            &.red {
                color: @red;
            }
        }
        .tips {
            padding: 10px 21px 66px;
            text-indent:28px;
            font-size: 14px;
            color: #78797B;
        }
        .btn {
            margin-bottom: 0;
            background-color: #fff;
            padding-top: 7px;
            //margin-bottom: 0;
            .back {
                border-color: #55B19F;
                color: #55B19F;
            }
        }
        .van-uploader__preview-delete {
            font-size: 24px; top: -9px; right: -9px;
        }
    }
</style>
